import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    admin: JSON.parse(localStorage.getItem('admin_info') || 'null'),
    token: localStorage.getItem('admin_token') || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('admin_token', token)
    },
    SET_ADMIN_INFO(state, admin) {
      state.admin = admin
      localStorage.setItem('admin_info', JSON.stringify(admin))
    },
    LOGOUT(state) {
      state.admin = null
      state.token = ''
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_info')
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setAdminInfo({ commit }, admin) {
      commit('SET_ADMIN_INFO', admin)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  modules: {}
})
